import { RadioButton } from 'common/components/';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import ExternalTransfer from '../ExternalTransfer';
import InnerTransfer from '../InnerTransfer';
import WalletTransfer from '../WalletTransfer';
import { staticStyles } from './style';

const getCurrentTab = ({ accountsOrWalletsEnabled, tradersEnabled }) => {
  if (accountsOrWalletsEnabled) {
    return 'inner';
  }
  if (tradersEnabled) {
    return 'trader';
  }
  return 'wallets';
};

const InternalTransfer = ({ accountsOrWalletsEnabled, tradersEnabled, account, addons }) => {
  const [transferType, setTransferType] = useState(
    getCurrentTab({
      accountsOrWalletsEnabled,
      tradersEnabled,
    })
  );
  const handleChange = transferType => {
    setTransferType(transferType);
  };

  return (
    <div className="InternalTransfer">
      <div className="InternalTransfer__select">
        <FormattedMessage id="justChooseOption">
          {txt => <span className="InternalTransfer__select-caption">{`${txt}:`}</span>}
        </FormattedMessage>
        {accountsOrWalletsEnabled && (
          <RadioButton
            name="transferType"
            textId="clientBetweenYourAccounts"
            value="inner"
            onChange={() => handleChange('inner')}
            checked={transferType === 'inner'}
            disabled={!accountsOrWalletsEnabled}
          />
        )}
        {tradersEnabled && (
          <RadioButton
            name="transferType"
            textId="clientToAnotherTrader"
            value="trader"
            onChange={() => handleChange('trader')}
            checked={transferType === 'trader'}
            disabled={!tradersEnabled}
          />
        )}
      </div>
      {accountsOrWalletsEnabled && transferType === 'inner' && (
        <InnerTransfer key="inner" initialValues={{ senderAccount: account }} />
      )}
      {tradersEnabled && transferType === 'trader' && addons.includes('wallet') && <WalletTransfer />}
      {tradersEnabled && transferType === 'trader' && addons.includes('walletAccounts') && (
        <ExternalTransfer key="anotherTraderMulti" initialValues={{ senderAccount: account }} isMultiWalletTransfer />
      )}
      {tradersEnabled &&
        transferType === 'trader' &&
        !addons.includes('wallet') &&
        !addons.includes('walletAccounts') && (
          <ExternalTransfer key="anotherTrader" initialValues={{ senderAccount: account }} />
        )}
      <style jsx global>
        {staticStyles}
      </style>
    </div>
  );
};

InternalTransfer.propTypes = {
  accountsOrWalletsEnabled: PropTypes.bool.isRequired,
  tradersEnabled: PropTypes.bool.isRequired,
  addons: PropTypes.array.isRequired,
  account: PropTypes.number,
};

InternalTransfer.defaultProps = {
  account: null,
};

export default connect(state => ({
  accountsOrWalletsEnabled:
    state.interfaceConfig.internalTransfers.accounts_enabled ||
    state.interfaceConfig.internalTransfers.from_wallet_enabled ||
    state.interfaceConfig.internalTransfers.from_wallet_account_enabled ||
    state.interfaceConfig.internalTransfers.to_wallet_enabled ||
    state.interfaceConfig.internalTransfers.to_wallet_account_enabled,
  tradersEnabled: state.interfaceConfig.internalTransfers.traders_enabled,
  addons: state.interfaceConfig.addons,
}))(InternalTransfer);
